export default {
	type: 'object',
	properties: {
		platformId: { type: 'string' },
		channelId: { type: 'string' },
	},
	required: ['platformId', 'channelId'],
}
